module.exports = {
          srcSet: __webpack_public_path__ + "09cc4710.jpg"+" 700w"+","+__webpack_public_path__ + "c0a1db37.jpg"+" 995w",
          images:[ {path: __webpack_public_path__ + "09cc4710.jpg",width: 700,height: 480},{path: __webpack_public_path__ + "c0a1db37.jpg",width: 995,height: 682}],
          src: __webpack_public_path__ + "09cc4710.jpg",
          toString:function(){return __webpack_public_path__ + "09cc4710.jpg"},
          
          width: 700,
          height: 480
        }